import { Link } from "react-router-dom";
import { Instagram, Youtube, Music2, Mail } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t, lp } = useLang();
  const NAV = [
    [t("footer.links.about"), "/o-mne"],
    [t("footer.links.workshop"), "/dilna"],
    [t("footer.links.partnership"), "/spoluprace"],
    [t("footer.links.races"), "/zavody"],
  ];
  return (
    <footer data-testid="site-footer" className="carbon-bg relative border-t border-white/10">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <div className="clip-corner-sm h-9 w-9 bg-[#1EA7FF]" />
              <span className="font-display text-2xl uppercase tracking-[0.1em]">FILIP VIMPEL</span>
              <span className="font-mono text-xs tracking-[0.2em] text-[#B7FF2A]">#606</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/50">{t("footer.desc")}</p>
            <div className="mt-5 flex items-center gap-2">
              <a
                href="https://www.instagram.com/driftex_/?hl=cs"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-instagram"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-white/10 text-white/60 transition-colors duration-200 hover:border-[#1EA7FF]/50 hover:text-[#1EA7FF]"
                aria-label="Instagram"
              >
                <Instagram className="h-4 w-4" />
              </a>
              <a
                href="https://www.youtube.com/@Driftex606"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-youtube"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-white/10 text-white/60 transition-colors duration-200 hover:border-[#1EA7FF]/50 hover:text-[#1EA7FF]"
                aria-label="YouTube"
              >
                <Youtube className="h-4 w-4" />
              </a>
              <a
                href="https://www.tiktok.com/@filipvimpel"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-tiktok"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-white/10 text-white/60 transition-colors duration-200 hover:border-[#1EA7FF]/50 hover:text-[#1EA7FF]"
                aria-label="TikTok"
              >
                <Music2 className="h-4 w-4" />
              </a>
              <a
                href="mailto:f.vimpel@seznam.cz"
                data-testid="footer-social-email"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-white/10 text-white/60 transition-colors duration-200 hover:border-[#B7FF2A]/50 hover:text-[#B7FF2A]"
                aria-label="Email"
              >
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* nav columns */}
          <div className="md:col-span-3">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-white/40">// {t("footer.sections")}</div>
            <ul className="mt-4 space-y-2">
              {NAV.map(([label, to]) => (
                <li key={to}>
                  <Link
                    to={lp(to)}
                    className="font-display text-lg uppercase tracking-[0.08em] text-white/65 transition-colors duration-200 hover:text-[#B7FF2A]"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-white/40">// {t("footer.quickContact")}</div>
            <div className="mt-4 space-y-2 text-sm text-white/55">
              <p>f.vimpel@seznam.cz</p>
              <p>+420 603 380 190</p>
              <p>{t("footer.location")}</p>
            </div>
            <Link
              to={lp("/kontakt")}
              data-testid="footer-contact-link"
              className="light-sweep clip-corner-sm mt-5 inline-flex items-center gap-2 border border-[#B7FF2A]/40 bg-[#B7FF2A]/10 px-5 py-2.5 font-display text-sm uppercase tracking-[0.14em] text-[#B7FF2A] transition-colors duration-200 hover:bg-[#B7FF2A]/20"
            >
              {t("footer.writeMe")}
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-6 font-mono text-xs text-white/35 sm:flex-row sm:items-center">
          <span>© {new Date().getFullYear()} DRIFTEX / Filip Vimpel. {t("footer.rights")}</span>
          <span className="tracking-[0.2em]">LETS SMOKE SOME TIRES — #606</span>
        </div>
      </div>
    </footer>
  );
};
